/**
 * Short phone-landscape viewport (e.g. Playwright `phone-landscape-844` = 844×390).
 * Used to collapse directory page chrome so map mode keeps a usable Leaflet pane.
 *
 * MQ is height+orientation only — not a one-off width breakpoint (RESPONSIVE_CONTRACT).
 */
import { useEffect, useState } from 'react';

/** Matches iPhone landscape height class (~390) with headroom under tablet portrait. */
export const SHORT_LANDSCAPE_MQ =
  '(orientation: landscape) and (max-height: 500px)';

function readShortLandscape(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(SHORT_LANDSCAPE_MQ).matches;
}

/** Sync-init matchMedia for short landscape; updates on orientation/resize. */
export function useShortLandscapeViewport(): boolean {
  const [shortLandscape, setShortLandscape] = useState(readShortLandscape);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    const media = window.matchMedia(SHORT_LANDSCAPE_MQ);
    const onChange = (): void => {
      setShortLandscape(media.matches);
    };
    onChange();
    media.addEventListener('change', onChange);
    return () => {
      media.removeEventListener('change', onChange);
    };
  }, []);

  return shortLandscape;
}
